import { render, staticRenderFns } from "./SDK.vue?vue&type=template&id=2f7e7a11&scoped=true&"
import script from "./SDK.vue?vue&type=script&lang=js&"
export * from "./SDK.vue?vue&type=script&lang=js&"
import style0 from "./SDK.vue?vue&type=style&index=0&id=2f7e7a11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e7a11",
  null
  
)

export default component.exports